import {
	SHOW_LOADING,
	GET_CAMPAIGN,
	LOAD_CAMPAIGN,
	UPDATE_CAMPAIGN,
	CREATE_CAMPAIGN,
	GET_CAMPAIGN_TEMPLATE_TYPES,
	LOAD_CAMPAIGN_TEMPLATE_TYPES,
	GET_WHATSAPP_NUMBERS,
	SAVE_WHATSAPP_NUMBERS,
	RESET_CAMPAIGN,
} from "../constants/Campaign";

export const getCampaign = (query) => {
	return {
		type: GET_CAMPAIGN,
		payload: query
	};
};
export const saveCampaign = (campaign) => {
	return {
		type: LOAD_CAMPAIGN,
		payload: campaign
	};
};
export const getCampaignTemplateType = () => {
	return {
		type: GET_CAMPAIGN_TEMPLATE_TYPES,
	};
};
export const saveCampaignTemplateType = (campaignTypes) => {
	return {
		type: LOAD_CAMPAIGN_TEMPLATE_TYPES,
		payload: campaignTypes,
	};
};
export const updateCampaign = ({data, query}) => {
	return {
		type: UPDATE_CAMPAIGN,
		payload: {data, query}
	};
};
export const createCampaign = ({data, query}) => {
	console.log("AAAAAAAABBBBBBB");
	return {
		type: CREATE_CAMPAIGN,
		payload: {data, query}
	};
};

export const showLoading = () => {
	return {
		type: SHOW_LOADING,
	};
};

export const resetCampaign = () => {
	return {
		type: RESET_CAMPAIGN,
	};
};

export const getWhatsappNumbers = () => {
	return {
		type: GET_WHATSAPP_NUMBERS
	}
}

export const saveWhatsappNumbers = (data) => {
	return {
		type: SAVE_WHATSAPP_NUMBERS,
		payload: data
	}
}
